/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Const } from "const";

export interface WebRTCConnection {
  status: string;
  frameRate: number;
  resolution: number;
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  channelArn: string;
}

/**
 * Judge to do connect or not
 * @param {WebRTCConnection} connection Connection info
 * @return {boolean} true: Do connect / false: Do not connect
 */
export function shouldConnect(connection?: WebRTCConnection): boolean {
  return (
    connection?.status === Const.webRtcStatusOpening ||
    (connection?.status === Const.webRtcStatusStreaming &&
      connection?.accessKeyId !== "")
  );
}
